import React from 'react';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <p className="m-0 text-center">© 2024 fait avec le ❤️ par Jordan</p>
      </div>
    </footer>
  );
}
